import { Actions } from '../../../components/CustomTable/types'

export const processItemActions = (item: any, isLastItem: boolean): any => {
  if (isLastItem) {
    return {
      ...item,
      actions: item?.actions
    }
  }

  const filteredActions = item?.actions?.filter((action: string) => action !== Actions.DELETE) || []
  const hasEdit = filteredActions.includes(Actions.EDIT)
  const hasRead = filteredActions.includes(Actions.READ)

  const actionsWithEdit = hasEdit ? filteredActions : [...filteredActions, Actions.EDIT]
  const finalActions = hasRead ? actionsWithEdit : [...actionsWithEdit, Actions.READ]

  return {
    ...item,
    actions: finalActions
  }
}
